module.exports = __webpack_public_path__ + "img/latest-news-with-heading.f04a179c.svg";